import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "library-banner";

export type library_banner_list = {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: string;
    search?: string;
    category_library?: string;
    start_date?: string;
    end_date?: string;
}
export type create_library_banner = {
    library_seq: number | string;
    library_banner_name: string;
    id_media_file: number | null;
    id_library_banner?: number | null;
}
export class LibraryBannerApi extends BaseAPI {
    static list(params: library_banner_list): Promise<AxiosResponse> {
        return this.api.get(`${path}/list`, { params: params })
    }
    static create(body: create_library_banner): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_library_banner: number, body: create_library_banner): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_library_banner}`, body)
    }
    static delete(id_library_banner: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_library_banner}`)
    }
    static findOne(id_library_banner: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_library_banner}`)
    }
}